// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../admin/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dropdown[data-v-e753c81e] .dropdown-menu {\n\tdisplay: none;\n}\n.dropdown.is-active[data-v-e753c81e] .dropdown-menu {\n\tdisplay: block;\n}\n", ""]);
// Exports
module.exports = exports;
